import { useState } from 'react';
import { createColour } from 'apiCalls/apiCalls';
import { TextField } from '@mui/material';
import { ErrorMessage } from 'components/CommonComponents';
import { PrimaryButton } from 'components/Buttons';
import {
    BORDER_RADIUS,
    FONT_SIZE_LARGE_NUMBER,
    FONT_SIZE_MEDIUM_NUMBER,
    PAD_EXTRA_LARGE,
} from 'providers/designSystem';

export const AddColoursComponent = () => {
    const [colour, setColour] = useState(null);
    const [error, setError] = useState(null);

    const resetInput = () => {
        setColour(null);
        document.querySelector('input').value = null;
    };

    const setColourFromInput = e => {
        setColour(e.target.value);
    };

    const submitColour = async (event, colour: string) => {
        event.preventDefault();

        try {
            await createColour(colour);
            setError(null);
            resetInput();
        } catch (e) {
            setError(e.message);
            resetInput();
        }
    };

    return (
        <>
            {error && <ErrorMessage />}
            <form
                onSubmit={e => submitColour(e, colour)}
                style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gap: `${PAD_EXTRA_LARGE}`,
                    padding: `${PAD_EXTRA_LARGE}`,
                    borderRadius: `${BORDER_RADIUS}`,
                }}
            >
                <TextField
                    label="Colour"
                    variant="standard"
                    onChange={setColourFromInput}
                    inputProps={{ style: { fontSize: FONT_SIZE_LARGE_NUMBER } }}
                    InputLabelProps={{ style: { fontSize: FONT_SIZE_MEDIUM_NUMBER } }}
                />
                <PrimaryButton onClick={() => null}>Add Colour</PrimaryButton>
            </form>
        </>
    );
};
